import React, { Component } from "react"
import PropTypes from "prop-types"
import GaraioLogoUrl from "../../images/garaio-logo.png"

export default class GaraioLogo extends Component {
  static propTypes = {
    className: PropTypes.string,
    alt: PropTypes.string,
    src: PropTypes.string,
  }

  render() {
    return (
      <img
        className={"logo common-garaio-logo " + this.props.className}
        alt="GARAIO Logo"
        src={GaraioLogoUrl}
        {...this.props}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/common/GaraioLogo.js